import environment from "@/config/environment"

export const isDevEnv = environment.env === "development"
